
/**
 * r : Read Only
 * rw : Read/Write
 * rwd : Read/Write/delete (full rights)
 */
export type PermissionRights = "r" | "rw" | "rwd";

/**
 * Permission as string 
 * <scope>:<name>:<rights>
 */
export type PermissionString = `${string}:${string}:${PermissionRights}`;


/**
 * Contains the required DTOs for permissions
 * @typedef {object} Role
 * @property id         : Generated
 * @property name       : Name of the role
 * @property permissions: List of PermissionString granted by the role
 */
export interface Role {
    id?: number; // ID is not set before insertion in DB

    /** Nom du rôle */
    name: string;

    /** Permissions associées au rôle */
    permissions: PermissionString[];

}

/**
 * Check if the rights pattern is valid
 * @param rights rights as string
 * @returns true if valid
 */
export function isValidRights(rights: string): boolean {
    return ["r", "rw", "rwd"].includes(rights);
}

/**
 * @type {object} Permission
 * @property scope  : Main field of the permission (ex : db, page, projects)
 * @property name   : Permission name of the scope (ex : role_table, admin_page, project_parameters)
 * @property rights : Level of the right associated to the permission (ex : "r","rw","rwd" )
 */
export interface Permission {
    scope: string;
    name: string;
    rights: PermissionRights;
    includedField?: string[];
    excludedField?: string[];
}

/**
 * Link between user and role, based on user uid. Not required to implement permissions.
 * @deprecated
 * @typedef {object} RoleAssignation
 * @property id         : Generated
 * @property userUid    : User Uid 
 * @property roleIds    : List of role table ids
 */
export interface RoleAssignation {
    id?: number;
    userUid: string;
    roleIds: number[]; // TODO : Utiliser plusieurs assignations plutôt qu'une seule avec une list
}

